<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom campaign-page"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <hero-block
      v-bind="heroBlock"
      edit-prefix="HeroBlock"
    />
    <div
      v-if="contentBlocks.length || (isEditable && contentBlocks.length)"
      v-edit="'ContentBlocks'"
      class="usp-block-wrapper"
    >
      <in-view
        v-for="(block, index) in contentBlocks"
        :key="'contentBlocks--' + block.contentId"
        :threshold="threshold"
        :threshold-type="'px'"
      >
        <component
          :is="block.component | kebab"
          v-bind="block"
          :class=" {'first': index === 0, 'last': index === contentBlocks.length -1}"
        />
      </in-view>
    </div>

    <section class="content-area-wrapper">
      <sub-heading
        v-if="title || isEditable"
        :v-edit-heading="'Title'"
        :heading="title"
      />

      <block-grid
        v-if="contentArea.length || (isEditable && contentArea.length)"
        v-edit="'ContentArea'"
        :blocks="contentArea"
      />
    </section>

    <section class="content-area-wrapper">
      <sub-heading
        v-if="titleTwo || isEditable"
        :v-edit-heading="'TitleTwo'"
        :heading="titleTwo"
      />

      <block-grid
        v-if="contentAreaTwo.length || (isEditable && contentAreaTwo.length)"
        v-edit="'ContentAreaTwo'"
        :blocks="contentAreaTwo"
        @open-folder-modal="openFolderModal"
      />
    </section>
    <div
      v-if="accordionBlocks.length || (isEditable && accordionBlocks.length)"
      class="accordion-block-wrapper"
    >
      <sub-heading
        v-if="accordionsHeading || isEditable"
        :v-edit-heading="'AccordionsHeading'"
        :heading="accordionsHeading"
      />

      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          v-edit="'AccordionBlocks'"
        >
          <accordion-group
            :items="accordionBlocks | stringify('content')"
            :limit="isEditable ? 0 : accordionShowMoreLimit"
            :tracking-scope="accordionsHeading"
          />
        </div>
      </in-view>
    </div>

    <navigation-blocks
      v-if="allNavigatablePages.length"
      :navigation-blocks="allNavigatablePages"
      :display-image-state="displayImagesInNavigationBlocks"
    >
      <sub-heading
        v-if="navigationHeading || isEditable"
        :v-edit-heading="'NavigationHeading'"
        :heading="navigationHeading"
      />
    </navigation-blocks>

    <additional-navigation-blocks
      v-if="isEditable"
      :items="additionalNavigatablePages"
    />

    <ica-add-single-recipe-to-folder-modal
      v-if="$root.isLoggedIn"
      :active="showFolderModal"
      :recipe-id="activeRecipeId"
      :recipe-name="activeRecipeTitle"
      :get-access-token-fn="getPublicAccessToken"
      :recipe-base-url="$root.envConfig.recipeExperienceApiBaseUrl"
      @save-to-folder="saveToFolder"
      @close-modal="closeModal"
    />
  </div>
</template>
<script>
import pageBlockTypes from '@/vue/mixins/pageBlockTypes'
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import recipeModalMixin from '@/vue/mixins/recipeModalMixin'

export default {
  name: "CampainPage",
  mixins: [pageBlockTypes, pageWithNavigation, recipeModalMixin],
  props: {
    title: {
      type: String,
      default: ""
    },
    contentArea: {
      type: Array,
      default: () => []
    },
    titleTwo: {
      type: String,
      default: ""
    },
    contentAreaTwo: {
      type: Array,
      default: () => []
    },
    uspBlocks: {
      type: Array,
      default: () => []
    },
    navigationHeading: {
      type: String,
      default: ""
    },
    navigationBlocks: {
      type: Array,
      default: () => []
    },
    accordionShowMoreLimit: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    // Temporary hack to bring life to a Mello-campaign page
    if (this.contentId === 'content_12415') {
      document.body.classList.add("mello")
    } else {
      document.body.classList.remove("mello")
    }
  }
}
</script>

<style lang="scss">
  .campaign-page {
    @import "@/style/_epiBackground.scss";
    @import "@/style/_uspblock.scss";
  }

  // Temporary hack to bring life to a Mello-campaign page
  body.mello {
    background-image: url('https://assets.icanet.se/image/upload/v1641818648/test/paljett_1000.webp');

    .section-heading-name {
      color: white;
    }

    .on-page-breadcrumbs {
      a,
      span {
        color: white;
      }

      a::after {
        border-color: white;
      }
    }
  }
</style>
